import { authService } from '@services';

export default [
  {
    component: () => import('./Dashboard.vue'),
    path: '',
    redirect: '/dashboard',
    children: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        component: () => import('./content/Dashboard.vue'),
        meta: {
          title: 'Dashboard',
        },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (authService.getGroups().includes('REGULATOR')) {
        next({ name: 'RegulatorHome' });
        return;
      }

      if (authService.getGroups().includes('ENTREPRENEUR')) {
        next({ name: 'Enterprises' });
        return;
      }

      if (authService.getGroups().includes('ADMIN')) {
        next({ name: 'AdminUsers' });
      }

      next();
    },
  },
];
